import { Modal, ModalBody, ModalFooter, Button, ModalHeader } from 'src/components/ui';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useLingui } from '@lingui/react';
import { renderTemplate } from '../../util/markdownTemplate';
import { useContext, useMemo } from 'react';
import UWEFormComponent from '../UWEFormComponent';
import Markdown from '../../components/markdown';
import { getTestId } from '../../hooks/useTestId';

const PARAMS = ['title', 'text', 'options', 'extraProps'];

const DEFAULT_OPTIONS = [
  { text: t`Confirm`, color: 'primary', value: true },
  { text: t`Cancel`, color: 'secondary', value: false },
];

function ConfirmationModal({
  title,
  text,
  options = DEFAULT_OPTIONS,
  // formData: rootFormData,
  onConfirm: onClose,
  extraProps: { reversible, markdownBlurb, blurbBeforeReversibleNotice } = {},
  isOpen,
  getCurrentFormObject = null,
  testIdBase = 'confirmation-modal',
}) {
  const { i18n } = useLingui();
  const markdownBlurbNode = useMemo(
    () => (
      <div className="pt-2">
        <Markdown>
          {markdownBlurb && getCurrentFormObject ? renderTemplate(markdownBlurb, { value: getCurrentFormObject() }, i18n.locale) : markdownBlurb}
        </Markdown>
      </div>
    ),
    [markdownBlurb, getCurrentFormObject, renderTemplate, getCurrentFormObject, i18n]
  );

  return (
    <Modal isOpen={isOpen} toggle={() => onClose()} className="modal-primary" size="md" backdrop>
      {title && <ModalHeader>{title}</ModalHeader>}
      <ModalBody className="text-center">
        <div>{text}</div>
        {blurbBeforeReversibleNotice ? markdownBlurbNode : null}
        {/* {!reversible ? (
          <div className="textBottomModalConfirm">
            <Trans>This action is irreversible</Trans>
          </div>
        ) : null} */}
        {blurbBeforeReversibleNotice ? null : markdownBlurbNode}
      </ModalBody>
      <ModalFooter className="justify-center">
        {options.map(({ text, color, onClick, value }, idx) => (
          <Button
            key={idx}
            onClick={() => (onClick ? onClick({ closeModal: onClose }) : onClose(value))}
            color={color || 'secondary'}
            {...getTestId(testIdBase, '.', 'option', '-', idx)}
          >
            {text || `Option ${idx}`}
          </Button>
        ))}
      </ModalFooter>
    </Modal>
  );
}

ConfirmationModal.PARAMS = PARAMS;

export default ConfirmationModal;
